import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

import { formatDateAndTime } from '../../../../utils/time';

const styles = theme => ({
  root: {},
  content: {
    backgroundColor: '#F4F8F9',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: theme.spacing(2),
  },
  paper: {
    padding: '20px',
    color: theme.palette.text.secondary,
    margin: 20,
    width: 160,
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    ...theme.Typography,
    color: '#044591',
    margin: 0,
  },
  button: {
    margin: 'auto',
    top: '30%',
    padding: '1px',
  },
  textField: {
    marginLeft: '10px',
    marginRight: '10px',
  },
});

class Condition extends React.Component {
  state = {
    selectedTab: 0,
    selectedApi: null,
    selectedEndpoint: 0,
    endpointParams: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      pushExperience: {
        toneId: 0,
        tag: '',
      },
    };
  }

  render() {
    let {
      classes,
      field,
      operator,
      value,
      question,
      date,
      picks,
      deleteCondition,
      indexCondition,
      enableDelete,
    } = this.props;
    if (operator == null) {
      field = question.name;
      operator = '';
    }

    if (date !== null) {
      value = formatDateAndTime(date);
    } else if (value !== null) {
      value = value.name;
    }

    return (
      <Paper className={classes.paper}>
        <Grid container spacing={3}>
          <Grid item xs={9}>
            <Grid item xs={12}>
              <Typography variant="body2">{field}</Typography>
            </Grid>
            <Grid item xs>
              {operator}
            </Grid>
            <Grid item xs>
              <Typography variant="body2" color={'secondary'}>
                {value.toString()}
              </Typography>
            </Grid>
            <Grid item xs>
              <Typography variant="body2" color={'secondary'}>
                {picks && picks.team1 && picks.team2 && picks.team1 + 'x' + picks.team2}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            {enableDelete && (
              <IconButton
                className={classes.button}
                aria-label="delete"
                size="small"
                onClick={() => deleteCondition(indexCondition)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            )}
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export default withStyles(styles)(Condition);
